import { Dispatch, ReactNode, SetStateAction } from 'react';
import { RfqFiltersModalProvider } from './modal-context';
import RfqFilterFormProvider from './form-context';
import RfqFiltersValueProvider from './filter-provider';
import { TabsState } from './tabs-context';
import ActiveProductsTabsProvider from './active-products-tabs-context';

interface Props {
  readonly tabsState: TabsState;
  readonly setTabsState: Dispatch<SetStateAction<TabsState>>;
  readonly children: ReactNode;
}

export default function RfqFilterProvider({
  children,
  setTabsState,
  tabsState,
}: Props) {
  return (
    <ActiveProductsTabsProvider
      tabsState={tabsState}
      setTabsState={setTabsState}
    >
      <RfqFiltersModalProvider>
        <RfqFilterFormProvider>
          <RfqFiltersValueProvider>{children}</RfqFiltersValueProvider>
        </RfqFilterFormProvider>
      </RfqFiltersModalProvider>
    </ActiveProductsTabsProvider>
  );
}
